import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import levelUpSpinningArrow from './images/levelUpSpinningArrow.gif';

registerImages('levels', {
  LevelUpSpinningArrow: levelUpSpinningArrow,
});

declare global {
  interface RegisteredImages {
    levels: Record<string, ImageSource | undefined>;
  }
}
